
  (function() {
    'use strict';

    // ---------- 配置 ----------
    const BASE_URL = 'https://cdn.shopify.com/s/files/1/0772/4112/3056/files/';
    // 触发器选择器数组（索引1-4）
    const triggerSelectors = [
      '#bcpo > div:nth-child(18) > div.single-option-selector > div:nth-child(1)',
      '#bcpo > div:nth-child(18) > div.single-option-selector > div:nth-child(2)',
      '#bcpo > div:nth-child(18) > div.single-option-selector > div:nth-child(3)',
      '#bcpo > div:nth-child(18) > div.single-option-selector > div:nth-child(4)'      
    ];
    // 对应的目标容器选择器（索引1-5）
    const targetSelectors = [
      '#bcpo > div:nth-child(19) > div.single-option-selector.bcpo-jumbo-swatches',      
      '#bcpo > div:nth-child(20) > div.single-option-selector.bcpo-jumbo-swatches',
      '#bcpo > div:nth-child(21) > div.single-option-selector.bcpo-jumbo-swatches',
      '#bcpo > div:nth-child(22) > div.single-option-selector.bcpo-jumbo-swatches'
    ];
    // 图片文件名列表（按触发器和 label 顺序）
    const imageFiles = {
      1: ['250gsm-2.webp', 'quilting-lining.webp', 'lining-white-150g.webp'],
      2: ['lining-white-90g.webp', 'lining-white-117g.webp', 'lining-white-140g.webp'],     
      3: ['lining-Same.webp'],
      4: ['No-lining.webp']
    };

    // ---------- 辅助函数 ----------
    function log(msg, data) {
      console.log('[ZoomIcon]', msg, data !== undefined ? data : '');
    }

    // 显示模态框（根据屏幕宽高比自动调整图片大小）
    function showZoomModal(imgUrl) {
      const modal = document.getElementById('zoomImageModal');
      if (!modal) {
        log('未找到 #zoomImageModal');
        return;
      }
      const modalImg = modal.querySelector('.zoom-image-modal__img');
      if (!modalImg) return;
      
      modalImg.style.opacity = '0';
      modalImg.src = '';
      modal.style.display = 'flex';
      
      const tempImg = new Image();
      tempImg.onload = function() {
        modalImg.src = imgUrl;
        // 根据屏幕宽高比设置图片尺寸
        const winWidth = window.innerWidth;
        const winHeight = window.innerHeight;
        if (winWidth > winHeight) {
          // 横屏：按高度的 95% 显示
          modalImg.style.width = 'auto';
          modalImg.style.height = '90vh';
        } else {
          // 竖屏：按宽度的 95% 显示
          modalImg.style.width = '90vw';
          modalImg.style.height = 'auto';
        }
        modalImg.style.opacity = '1';
      };
      tempImg.onerror = function() {
        modalImg.src = imgUrl;
        // 即使加载失败也显示占位（图片可能404，但至少弹出框）
        modalImg.style.width = 'auto';
        modalImg.style.height = 'auto';
        modalImg.style.opacity = '1';
        log('图片加载失败', imgUrl);
      };
      tempImg.src = imgUrl;
    }

    function closeZoomModal() {
      const modal = document.getElementById('zoomImageModal');
      if (modal) modal.style.display = 'none';
    }

    // 移除容器内所有 label 上的图标
    function removeIconsFromContainer(container) {
      if (!container) return;
      const labels = container.querySelectorAll('label.bcpo-front-image-label');
      labels.forEach(label => {
        const existingIcon = label.querySelector('.zoom-icon');
        if (existingIcon) existingIcon.remove();
        label.classList.remove('zoom-icon-added');
      });
      log('已移除容器内的所有图标');
    }

    // 为容器内的每个 label 添加图标，并绑定指定的图片 URL 列表
    function addIconsToContainer(container, imageList) {
      if (!container) {
        log('容器不存在，无法添加图标');
        return;
      }
      const labels = container.querySelectorAll('label.bcpo-front-image-label');
      if (labels.length === 0) {
        log('容器内没有找到 label');
        return;
      }
      
      // 如果图片列表不足，使用最后一个图片填充剩余 label（并发出警告）
      let finalImageList = [...imageList];
      if (labels.length > finalImageList.length) {
        const lastImage = finalImageList[finalImageList.length - 1];
        while (finalImageList.length < labels.length) {
          finalImageList.push(lastImage);
        }
        log(`警告：图片列表长度(${imageList.length})不足 label 数量(${labels.length})，已使用最后一个图片 "${lastImage}" 填充剩余位置`);
      }
      
      for (let i = 0; i < labels.length; i++) {
        const label = labels[i];
        if (label.classList.contains('zoom-icon-added')) continue;
        const imgUrl = BASE_URL + finalImageList[i];
        // 创建图标
        const icon = document.createElement('span');
        icon.className = 'zoom-icon';
        // 创建 SVG 元素
        const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svg.setAttribute("viewBox", "0 0 24 24");
        svg.setAttribute("stroke", "currentColor");
        svg.setAttribute("stroke-width", "2");
        svg.setAttribute("stroke-linecap", "round");
        svg.setAttribute("stroke-linejoin", "round");

        // 填充内部子元素
        svg.innerHTML = '<circle cx="11" cy="11" r="6"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>';

        // 清空容器并把安全的 svg 节点添加进去
        icon.innerHTML = ""; 
        icon.appendChild(svg);
        //icon.innerHTML = '<svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="6"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';        
        
        icon.setAttribute('aria-label', 'Enlarge');
        icon.addEventListener('click', (function(url) {
          return function(e) {
            e.stopPropagation();
            showZoomModal(url);
          };
        })(imgUrl));
        label.appendChild(icon);
        label.classList.add('zoom-icon-added');
        log(`为第 ${i+1} 个 label 添加图标，图片: ${imgUrl}`);
      }
    }

    // 处理触发器点击（根据索引）
    function handleTriggerClick(triggerIndex) {
      log(`触发器 ${triggerIndex} 被点击`);
      const targetSelector = targetSelectors[triggerIndex - 1];
      const targetContainer = document.querySelector(targetSelector);
      if (!targetContainer) {
        log(`目标容器未找到: ${targetSelector}，等待出现...`);
        // 轮询等待容器出现（最多9秒）
        let attempts = 0;
        const maxAttempts = 30;
        const interval = setInterval(() => {
          attempts++;
          const container = document.querySelector(targetSelector);
          if (container) {
            clearInterval(interval);
            log(`目标容器已出现，开始添加图标`);
            removeIconsFromContainer(container);
            addIconsToContainer(container, imageFiles[triggerIndex]);
          } else if (attempts >= maxAttempts) {
            clearInterval(interval);
            log(`等待超时，未找到目标容器: ${targetSelector}`);
          }
        }, 300);
        return;
      }
      // 容器已存在：先清除旧图标，再添加新图标
      removeIconsFromContainer(targetContainer);
      addIconsToContainer(targetContainer, imageFiles[triggerIndex]);
    }

    // ---------- 初始化：绑定触发器 ----------
    function bindTriggers() {
      for (let i = 1; i <= triggerSelectors.length; i++) {
        const selector = triggerSelectors[i - 1];
        const triggerElement = document.querySelector(selector);
        if (triggerElement) {
          triggerElement.addEventListener('click', (function(idx) {
            return function() { handleTriggerClick(idx); };
          })(i));
          log(`触发器 ${i} 绑定成功`, selector);
        } else {
          log(`触发器 ${i} 未找到，等待动态出现`, selector);
          // 使用 MutationObserver 等待触发器出现
          const observer = new MutationObserver((mutations, obs) => {
            const el = document.querySelector(selector);
            if (el) {
              obs.disconnect();
              el.addEventListener('click', (function(idx) {
                return function() { handleTriggerClick(idx); };
              })(i));
              log(`触发器 ${i} 动态绑定成功`, selector);
            }
          });
          observer.observe(document.body, { childList: true, subtree: true });
          setTimeout(() => observer.disconnect(), 10000);
        }
      }
    }

    // 页面加载完成后开始绑定
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindTriggers);
    } else {
      bindTriggers();
    }

    // 模态框关闭事件
    document.addEventListener('click', (e) => {
      const modal = document.getElementById('zoomImageModal');
      if (!modal) return;
      const closeBtn = modal.querySelector('.zoom-image-modal__close');
      if (closeBtn && closeBtn.contains(e.target)) {
        closeZoomModal();
      } else if (e.target === modal) {
        closeZoomModal();
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeZoomModal();
    });
  })();
